import * as React from "react"
import PropTypes from "prop-types"

export const AccordionContext = React.createContext()

export const Accordion = ({ children, defaultExpanded = false, id }) => {
  const [expanded, setExpanded] = React.useState(defaultExpanded)

  const autoId = `accordion-${React.useId}`
  const accordionId = id || autoId
  const accordionSummaryId = `${accordionId}-summary`
  const accordionContentId = `${accordionId}-content`

  return (
    <AccordionContext.Provider
      value={{
        expanded,
        setExpanded,
        accordionId,
        accordionSummaryId,
        accordionContentId,
      }}
    >
      <div>{children}</div>
    </AccordionContext.Provider>
  )
}

Accordion.propTypes = {
  className: PropTypes.string,
  defaultExpanded: PropTypes.bool,
  id: PropTypes.number,
}
